import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';

import { Amount } from 'ib/internetbank-core/ib-models/amount';
import { MatrixRouterParameters } from 'ib/internetbank-core/utils/matrix-router-parameters';


import { OperationOptions } from '../../../../../../common/operation-wizard/operation-entities';
import { PaymentsBudgetWithSbpComponent } from '../../../../../../pages/payments/pages/payments-budget-with-sbp/payments-budget-with-sbp.component';
import { RouteAction } from '../../../../../../shared/notifications/models/route-action';
import { SettingsService } from '../../../../../settings/settings.service';
import { PaymentTypeEnum } from '../../../../transfers/budget-transfer-search/budget-transfer-search.service';
import { BudgetTransferPathSegmentEnum } from '../../../../transfers/budget-transfer-wizard/budget-transfer-types';
import { ExternalTransferTypes } from '../../../../transfers/external-transfer-wizard/external-transfer-types';
import { BaseTransferRouteUtils } from '../../../../transfers/route-utils/base-transfer.route-utils';
import { BudgetTransferRouteUtils } from '../../../../transfers/route-utils/budget-transfer.route-utils';
import { FullExternalTransferRouteUtils } from '../../../../transfers/route-utils/full-external-transfer.route-utils';

import { ChargeForWidget } from './change-item-entites';


@Component({
	selector: 'app-charge-item',
	templateUrl: './charge-item.component.html',
	styleUrls: ['./charge-item.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChargeItemComponent implements OnInit {
	@Input()
	public charge: ChargeForWidget;

	@Input()
	public onSearchTab: boolean;

	@Input()
	public searchDocNumber: string | undefined; // 274002213277 - test

	public action: RouteAction;

	public ngOnInit(): void {
		this.initAction();
	}

	public getAmountToPay(): Amount {
		if (this.charge.discountInfo) {
			return this.charge.discountInfo.discountAmount;
		}

		return this.charge.amount;
	}

	private initAction(): void {
		if (this.charge.payeeId) {
			if (this.charge.internalId && this.charge.subscriptionId) {
				this.action = new RouteAction();
				this.action.title = 'Оплатить';
				this.action.route = [
					'/operations/payments/payment-process-wizard/',
					this.charge.payeeCategoryId,
					this.charge.payeeId,
					OperationOptions.FROM_ACCRUALS_SUBSCRIPTION,
				];
				this.action.queryParams = {
					internalId: `${this.charge.internalId}`,
					subscriptionId: this.charge.subscriptionId,
				};
			} else if (this.searchDocNumber) {
				this.action = new RouteAction();
				this.action.title = 'Оплатить';
				this.action.route = [
					'/operations/payments/payment-process-wizard/',
					this.charge.payeeCategoryId,
					this.charge.payeeId,
					OperationOptions.FROM_ACCRUALS_SEARCH,
				];
				this.action.queryParams = {
					documentNumber: this.searchDocNumber,
					amountValue: this.charge.amount.amount?.toString(),
					amountCurrency: this.charge.amount.currency?.toString(),
				};
			}

			if (this.charge.payeeId === SettingsService.GIS_PAYEE_ID) {
				this.action = new RouteAction();
				this.action.title = 'Оплатить';
				this.action.route = FullExternalTransferRouteUtils.routeWithOperationAndIdForOperationOptions.createNavigationParametersForPath({
					transferTab: ExternalTransferTypes.JURIDICAL_PERSON,
					operationOptions: OperationOptions.FROM_ACCRUALS_SUBSCRIPTION,
					idForOperationOption: this.charge.payeeId.toString(),
				}).routerLink;

				this.action.queryParams = { internalId: `${this.charge.internalId}` };
			}

		} else {
			this.action = new RouteAction();
			this.action.title = 'Оплатить';
			this.action.route = [
				BaseTransferRouteUtils.getPath(BudgetTransferRouteUtils.urlPart),
				BudgetTransferPathSegmentEnum[this.charge.paymentTypeEnum || PaymentTypeEnum.BUDGET_OTHER_PAY],
				'fromsearch',
				'uin',
				(this.charge.uin ?? '').toString(),
			];

			this.action.route = this.createRoutingLink(this.charge);
		}
	}

	private createRoutingLink(chargeDetail: ChargeForWidget): Array<string | MatrixRouterParameters> {
		return PaymentsBudgetWithSbpComponent.createRoutingLinkByChargeDetail(chargeDetail.uin);
	}
}
